module.exports = __webpack_public_path__ + "img/eden-hazard.e601bb7f.png";